module.exports = __webpack_public_path__ + "fonts/unicredit-medium.fb417abd.eot";